import { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { fetchSingleBuilding } from '../../../../../../reducers/buildingSelectorReducer'
import api from '../../../../../../api/api'
import { useSnackbar } from '../../../../../../helpers/hooks/useSnackbar'
import { toAmenityCardItem } from '../../../helpers'

const AddReward = ({
  building,
  onBack = () => {},
  onClose = () => {},
  fetchSingleBuilding = () => {},
}) => {
  const { t } = useTranslation(['rewards-table', 'rewards', 'common'])
  const [reward, setReward] = useState(null)
  const [amenities, setAmenities] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const { displaySnackbar } = useSnackbar()

  const fetchAmenities = async () => {
    try {
      setIsLoading(true)
      const { data } = await api.getLoyaltyAmenities(building.id)
      setAmenities(data.map(toAmenityCardItem))
    } catch ({ message }) {
      console.error(message)
      displaySnackbar(message, true)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    if (building) {
      fetchAmenities()
    }
  }, [building])

  const onSubmitFinally = async () => {
    if (building.id) {
      await fetchSingleBuilding(building.id)
    }
    onClose()
  }

  const onSubmit = async () => {
    try {
      await api.createLoyaltyReward({
        buildingId: building.id,
        amenityId: reward.id,
        type: 'amenity',
      })
      displaySnackbar(t('rewards-table:addReward.createSuccess', { name: reward.name }))
    } catch ({ message }) {
      console.error(message)
      displaySnackbar(t('rewards-table:addReward.createError'), true)
    } finally {
      onSubmitFinally()
    }
  }

  return (
    <div>
      <div
        className={`rewards-modal-content rewards-base-view add-reward ${
          isLoading ? 'is-loading' : ''
        }`}
      >
        <div className="rewards-modal-input-row">
          <div className="custom-cards-container">
            {amenities.map((element, index) => (
              <div
                className={`custom-card-item ${
                  reward && reward.id === element.id ? 'selected' : ''
                } ${element.isUsed ? 'disabled' : ''}`}
                key={`${element.name}_${index}`}
                onClick={() => setReward(element)}
              >
                <img
                  className="custom-card-item__image"
                  src={element.cardImageUrl}
                  alt={element.name}
                />
                <span className="custom-card-item__title">{element.name}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="rewards-modal-actions">
        <button className="button button-gray" onClick={onBack}>
          {t('common:actions.back')}
        </button>
        <button className="button button-primary auto-width" disabled={!reward} onClick={onSubmit}>
          {t('rewards:settingsToolbar.addRewardButton')}
        </button>
      </div>
    </div>
  )
}

AddReward.propTypes = {
  building: PropTypes.object,
  onBack: PropTypes.func,
  onClose: PropTypes.func,
  fetchSingleBuilding: PropTypes.func,
}

export default connect(null, {
  fetchSingleBuilding,
})(AddReward)
